module.exports = __webpack_public_path__ + "img/tu05.d5cc1b47.png";